import {singleton} from "tsyringe";
import {container} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";
import {OpenNewIssueTypeDialogCommand} from "../open-new-issue-type-dialog.command";
import {UiHelper} from "../../helpers/ui.helper";
import {IssueType} from "../../domain/entities/issue-type.entity";
import {AbstractCommand} from "../abstract.command";
import {EntityManager} from "../../persistence/entity.manager";

@CommandHandler(OpenNewIssueTypeDialogCommand)
@singleton()
export class OpenNewIssueTypeDialogCommandHandler implements ICommandHandler<void> {
    
    public async handle(command: ICommand<void>): Promise<void> {
        const entityManager = container.resolve(EntityManager);
        const issueTypeRepository = entityManager.getRepositoryForEntity(IssueType);
        
        if (!issueTypeRepository) {
            throw new Error('IssueType repository not found');
        }
        
        const issueType = await issueTypeRepository.create();
        
        UiHelper.openDialogEntityEdit<AbstractCommand<IssueType>>(
            IssueType,
            issueType,
            {
                creationMode: true,
                closable: true
            }
        );
    }
}